// extracted by mini-css-extract-plugin
module.exports = {"CseCandidateForm":"CseCandidateCreate_CseCandidateForm__3xqLf","DeleteButton":"CseCandidateCreate_DeleteButton__24osE"};